<div class="right_col screen-height u_scrns edit-page dashboard-shell" role="main">
  <div class="container-fluid dashboard-container">
    <header class="dashboard-header" style="display: flex; justify-content: space-between; align-items: center;">
      <div>
        <h1>Dashboard</h1>
      </div>
      <div style="display: flex; align-items: center; gap: 10px;">
        <label for="exchangeRate" style="margin: 0; font-weight: 500;">Exchange Rate (to USD):</label>
        <input type="number" id="exchangeRate" class="form-control" [value]="exchangeRate" (input)="updateExchangeRate($event)" style="width: 100px; display: inline-block;" />
      </div>
    </header>

    <section class="dashboard-stats" *ngIf="!isLoading; else loadingStats">
      <article class="stat-card" *ngFor="let stat of stats">
        <div class="stat-icon" [ngClass]="stat.iconClass">
          <i class="fa" [ngClass]="stat.icon" aria-hidden="true"></i>
        </div>
        <div class="stat-content">
          <p class="stat-label">{{ stat.label }}</p>
          <h2>{{ stat.value }}</h2>
          <span class="stat-meta">{{ stat.meta }}</span>
        </div>
      </article>
    </section>

    <ng-template #loadingStats>
      <section class="dashboard-stats">
        <article class="stat-card skeleton-card" *ngFor="let item of [1,2,3,4]"></article>
      </section>
    </ng-template>

    <section class="management-grid">
      <article class="management-card" *ngFor="let card of managementCards">
        <div class="management-card__icon" [ngClass]="card.iconClass">
          <i class="fa" [ngClass]="card.icon" aria-hidden="true"></i>
        </div>
        <div class="management-card__body">
          <h3>{{ card.title }}</h3>
          <p>{{ card.description }}</p>
        </div>
        <a class="management-card__action" [routerLink]="card.route">{{ card.label }}</a>
      </article>
    </section>

    <section class="chart-grid">
      <article class="chart-card">
        <div class="chart-card__header">
          <div>
            <h3>Plan Revenue</h3>
            <p>Monthly revenue by plan</p>
          </div>
          <select aria-label="Select revenue chart type" (change)="onOptionSelected($event.target.value)" class="chart-select">
            <option value="bar">Bar</option>
            <option value="line">Line</option>
            <option value="pie">Pie</option>
          </select>
        </div>
        <div class="chart-wrapper">
          <canvas id="myChart"></canvas>
        </div>
      </article>

      <article class="chart-card">
        <div class="chart-card__header">
          <div>
            <h3>Plan Subscribers</h3>
            <p>Current subscribers by plan</p>
          </div>
          <select aria-label="Select subscriber chart type" (change)="onOptionSelectedForSubs($event.target.value)" class="chart-select">
            <option value="bar">Bar</option>
            <option value="line">Line</option>
            <option value="pie">Pie</option>
          </select>
        </div>
        <div class="chart-wrapper">
          <canvas id="myChartForSubscription"></canvas>
        </div>
      </article>
    </section>
  </div>
</div>